import { Tooltip as TooltipPrimitive } from 'radix-ui'
import type { ReactNode } from 'react'
import s from './Tooltip.module.css'

type TooltipProps = {
  content: ReactNode
  children: ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
}

/**
 * Своя `Provider` на каждый экземпляр — самодостаточно под минимальный интерфейс брифа
 * (`<Tooltip content>{children}</Tooltip>`, без отдельного провайдера-обёртки на всё
 * приложение, как у `Toast`). Плата: Radix не сможет схлопнуть задержку в 400мс при переходе
 * между соседними тултипами (это умеет только общий на всё дерево `Tooltip.Provider`) — при
 * большом количестве тултипов рядом (например, в таблице) это стоит пересмотреть.
 *
 * `data-state` тултипа — не `"open"/"closed"`, как у Popover/Dialog, а `"delayed-open" |
 * "instant-open" | "closed"` (node_modules/@radix-ui/react-tooltip/dist/index.mjs:106) —
 * "instant-open" бывает при открытии по фокусу с клавиатуры, без ожидания задержки.
 * `content[data-state='open']` (по образцу Popover) тут просто не сработал бы.
 */
export function Tooltip({ content, children, side = 'top' }: TooltipProps) {
  return (
    <TooltipPrimitive.Provider delayDuration={400}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content className={s.content} side={side} sideOffset={6}>
            {content}
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  )
}
